export default __webpack_public_path__ + "static/media/wa-2531.e74878a8.jpg";